module.exports = __webpack_public_path__ + "h5/img/noBank.c621bb3a.png";